import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Greece() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Greece') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [cname, setCname] = useState();
    const [legal, setLegal] = useState();
    const [phone, setPhone] = useState();
    const [technical, setTechnical] = useState();
    const [vat, setVat] = useState();
    const [ctax, setCtax] = useState();
    const [city, setCity] = useState();
    const [streetName, setStreetName] = useState();
    const [streetNumber, setStreetNumber] = useState();
    const [location, setLocation] = useState();
    const [zip, setZip] = useState();

    const [provider, setProvider] = useState();
    const [signature, setSignature] = useState();
    const [companyStamp, setCompanyStamp] = useState();
    const [place, setPlace] = useState();
    const [date, setDate] = useState();

    const [legalRep, setLegalRep] = useState();
    const [signatureCust, setSignatureCust] = useState();
    const [companyStampCust, setCompanyStampCust] = useState();
    const [placeCust, setPlaceCust] = useState();
    const [dateCust, setDateCust] = useState();


    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        document.querySelector('#cname').value = form?.country?.companyDetails?.cname ?? '';
        document.querySelector('#legal').value = form?.country?.companyDetails?.legal ?? '';
        document.querySelector('#phone').value = form?.country?.companyDetails?.phone ?? '';
        document.querySelector('#technical').value = form?.country?.companyDetails?.technical ?? '';
        document.querySelector('#vat').value = form?.country?.companyDetails?.vat ?? '';
        document.querySelector('#ctax').value = form?.country?.companyDetails?.ctax ?? '';
        setCname(form?.country?.companyDetails?.cname ?? '');
        setLegal(form?.country?.companyDetails?.legal ?? '');
        setPhone(form?.country?.companyDetails?.phone ?? '');
        setTechnical(form?.country?.companyDetails?.technical ?? '');
        setVat(form?.country?.companyDetails?.vat ?? '');
        setCtax(form?.country?.companyDetails?.ctax ?? '');


        document.querySelector('#city').value = form?.country?.companyDetails?.city ?? '';
        document.querySelector('#streetName').value = form?.country?.companyDetails?.streetName ?? '';
        document.querySelector('#streetNumber').value = form?.country?.companyDetails?.streetNumber ?? '';
        document.querySelector('#location').value = form?.country?.companyDetails?.location ?? '';
        document.querySelector('#zip').value = form?.country?.companyDetails?.zip ?? '';
        document.querySelector('#provider').value = form?.country?.companyDetails?.provider ?? '';
        document.querySelector('#signature').value = form?.country?.companyDetails?.signature ?? '';
        document.querySelector('#companyStamp').value = form?.country?.companyDetails?.companyStamp ?? '';
        document.querySelector('#place').value = form?.country?.companyDetails?.place ?? '';
        document.querySelector('#date').value = form?.country?.companyDetails?.date ?? '';
        setCity(form?.country?.companyDetails?.city ?? '');
        setStreetName(form?.country?.companyDetails?.streetName ?? '');
        setStreetNumber(form?.country?.companyDetails?.streetNumber ?? '');
        setLocation(form?.country?.companyDetails?.location ?? '');
        setZip(form?.country?.companyDetails?.zip ?? '');
        setTableDataRange(form?.country?.companyDetails?.tableDataRange ?? []);
        setProvider(form?.country?.companyDetails?.provider ?? '');
        setCompanyStamp(form?.country?.companyDetails?.companyStamp ?? '');
        setSignature(form?.country?.companyDetails?.signature ?? '');
        setPlace(form?.country?.companyDetails?.place ?? '');
        setDate(form?.country?.companyDetails?.date ?? '');

        document.querySelector('#legalRep').value = form?.country?.custDetails?.legalRep ?? '';
        document.querySelector('#signatureCust').value = form?.country?.custDetails?.signatureCust ?? '';
        document.querySelector('#companyStampCust').value = form?.country?.custDetails?.companyStampCust ?? '';
        document.querySelector('#placeCust').value = form?.country?.custDetails?.placeCust ?? '';
        document.querySelector('#dateCust').value = form?.country?.custDetails?.dateCust ?? '';
        setLegalRep(form?.country?.custDetails?.legalRep ?? '');
        setSignatureCust(form?.country?.custDetails?.companyStampCust ?? '');
        setCompanyStampCust(form?.country?.custDetails?.signatureCust ?? '');
        setPlaceCust(form?.country?.custDetails?.placeCust ?? '');
        setDateCust(form?.country?.custDetails?.dateCust ?? '');

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-indexed, so index 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '',
                eNumber: row[1] ? row[1].toString() : '',
            }));

            setTableDataRange(formattedDataRange);

            // Validate each row: must be numeric and not empty
            formattedDataRange.forEach(row => {
                const isStartValid = /^\d+$/.test(row.sNumber);
                const isEndValid = /^\d+$/.test(row.eNumber);

                setValidationStates(prev => ({
                    ...prev,
                    [`startNumber-${row.id}`]: isStartValid,
                    [`endNumber-${row.id}`]: isEndValid,
                }));
            });
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableDataRange([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Greece",
            "companyDetails": {
                "cname": cname,
                "legal": legal,
                "phone": phone,
                "technical": technical,
                "vat": vat,
                "ctax": ctax,
                "city": city,
                "streetName": streetName,
                "streetNumber": streetNumber,
                "location": location,
                "zip": zip,
                "tableDataRange": tableDataRange,
                "provider": provider,
                "signature": signature,
                "companyStamp": companyStamp,
                "place": place,
                "date": date
            },
            "custDetails": {
                "legalRep": legalRep,
                "signatureCust": signatureCust,
                "companyStampCust": companyStampCust,
                "placeCust": placeCust,
                "dateCust": dateCust
            },
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};

        if (!cname) {
            validationErrors.cname = 'Please fill in Company Name';
        }
        if (!legal) {
            validationErrors.legal = 'please fill in Legal representative';
        }
        if (!phone) {
            validationErrors.phone = 'please fill in Contact Phone Number';
        }
        if (!vat) {
            validationErrors.vat = 'please fill in Company VAT Number';
        }
        if (!ctax) {
            validationErrors.ctax = 'please fill in Company Tax Office';
        }
        if (!city) {
            validationErrors.city = 'please fill in City';
        }
        if (!streetName) {
            validationErrors.streetName = 'please fill in Street Name';
        }
        if (!streetNumber) {
            validationErrors.streetNumber = 'please fill in Street Number';
        }
        if (!location) {
            validationErrors.location = 'please fill in Location';
        }
        if (!zip) {
            validationErrors.zip = 'please fill in Zip Number';
        }

        // Ensure both Start Number and End Number are provided in Range Table
        tableDataRange.forEach(row => {
            const startId = `startNumber-${row.id}`;
            const endId = `endNumber-${row.id}`;

            // Validate start number
            if (!row.sNumber) {
                validationErrors[startId] = 'Please fill in the start of the number range.';
            } else if (!/^\d+$/.test(row.sNumber)) {
                validationErrors[startId] = 'Start number must be numeric.';
            }

            // Validate end number
            if (!row.eNumber) {
                validationErrors[endId] = 'Please fill in the end of the number range.';
            } else if (!/^\d+$/.test(row.eNumber)) {
                validationErrors[endId] = 'End number must be numeric.';
            }
        });

        if (!provider) {
            validationErrors.provider = 'please fill in Provider';
        }
        if (!signature) {
            validationErrors.signature = 'please fill in Signature';
        }
        if (!companyStamp) {
            validationErrors.companyStamp = 'please fill in Company stamp';
        }
        if (!place) {
            validationErrors.place = 'please fill in place';
        }
        if (!date) {
            validationErrors.date = 'please fill in Date';
        }

        if (!legalRep) {
            validationErrors.legalRep = 'please fill in Legal Representative’s Full Name';
        }
        if (!signatureCust) {
            validationErrors.signatureCust = 'please fill in Signature';
        }
        if (!companyStampCust) {
            validationErrors.companyStampCust = 'please fill in Company Stamp';
        }
        if (!placeCust) {
            validationErrors.placeCust = 'please fill in Place';
        }
        if (!dateCust) {
            validationErrors.dateCust = 'please fill in Date';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            //Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;

        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }
        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = cname + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                    <h2 className='heading'>ΙΤΗΣΗ ΦΟΡΗΤΟΤΗΤΑΣ ΑΡΙΘΜΩΝ / NUMBER PORTABILITY APPLICATION</h2> <br></br>
                    <h2 className='heading'>Στοιχεία Εταιρείας / Company details</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('cname')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Επωνυμία / Company Name*</label> <br />
                            <input
                                onChange={(e) => setCname(e.target.value)}
                                type="text"
                                id="cname"
                                placeholder=""
                                className={`inputbox ${validationStates.cname === false ? 'error' : ''}`}
                                onBlur={() => validateInput('cname', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'cname' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Επωνυμία / Enter Company Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('legal')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label style={{ whiteSpace: 'nowrap' }}>
                                Όνοματεπώνυμο Νόμιμου Εκπροσώπου / Legal Representative’s Full Name*
                            </label>
                            <br />
                            <input
                                onChange={(e) => setLegal(e.target.value)}
                                type="text"
                                id="legal"
                                placeholder=""
                                className={`inputbox ${validationStates.legal === false ? 'error' : ''}`}
                                onBlur={() => validateInput('legal', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'legal' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Όνοματεπώνυμο Νόμιμου Εκπροσώπου / Enter Legal Representative’s Full Name
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('phone')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Τηλέφωνο Επικοινωνίας / Contact Phone Number*</label> <br />
                            <input
                                onChange={(e) => setPhone(e.target.value)}
                                type="text"
                                id="phone"
                                placeholder=""
                                className={`inputbox ${validationStates.phone === false ? 'error' : ''}`}
                                onBlur={() => validateInput('phone', /^\d+$/)}

                            />
                            {hoveredField === 'phone' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Τηλέφωνο Επικοινωνίας / Enter Contact Phone Number
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('technical')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Τεχνικός Διευθυντής / Technical Manager</label> <br />
                            <input
                                onChange={(e) => setTechnical(e.target.value)}
                                type="text"
                                id="technical"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'technical' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Τεχνικό Διευθυντή / Enter Technical Manager
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('vat')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>ΦΜ Εταιρίας / Company VAT Number*</label> <br />
                            <input
                                onChange={(e) => setVat(e.target.value)}
                                type="text"
                                id="vat"
                                placeholder=""
                                className={`inputbox ${validationStates.vat === false ? 'error' : ''}`}
                                onBlur={() => validateInput('vat', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'vat' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε ΑΦΜ Εταιρίας / Enter Company VAT Number
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('ctax')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>ΔΟΥ Εταιρίας / Company Tax Office*</label> <br />
                            <input
                                onChange={(e) => setCtax(e.target.value)}
                                type="text"
                                id="ctax"
                                placeholder=""
                                className={`inputbox ${validationStates.ctax === false ? 'error' : ''}`}
                                onBlur={() => validateInput('ctax', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'ctax' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε ΔΟΥ Εταιρίας / Enter Company Tax Office
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Πόλη / City*</label> <br />
                            <input
                                onChange={(e) => setCity(e.target.value)}
                                type="text"
                                id="city"
                                placeholder=""
                                className={`inputbox ${validationStates.city === false ? 'error' : ''}`}
                                onBlur={() => validateInput('city', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'city' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Πόλη/ Enter City
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('streetName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Οδός / Street Name*</label> <br />
                            <input
                                onChange={(e) => setStreetName(e.target.value)}
                                type="text"
                                id="streetName"
                                placeholder=""
                                className={`inputbox ${validationStates.streetName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('streetName', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'streetName' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Οδό / Enter Street Name
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('streetNumber')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Αριθμός / Street Number*</label> <br />
                            <input
                                onChange={(e) => setStreetNumber(e.target.value)}
                                type="text"
                                id="streetNumber"
                                placeholder=""
                                className={`inputbox ${validationStates.streetNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('streetNumber', /^\d+$/)}

                            />
                            {hoveredField === 'streetNumber' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Αριθμό / Enter Street Number
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('location')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Περιοχή / Location*</label> <br />
                            <input
                                onChange={(e) => setLocation(e.target.value)}
                                type="text"
                                id="location"
                                placeholder=""
                                className={`inputbox ${validationStates.location === false ? 'error' : ''}`}
                                onBlur={() => validateInput('location', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'location' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Περιοχή / Enter Location
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('zip')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Ταχ. Κωδ. / Zip Code*</label> <br />
                            <input
                                onChange={(e) => setZip(e.target.value)}
                                type="text"
                                id="zip"
                                placeholder=""
                                className={`inputbox ${validationStates.zip === false ? 'error' : ''}`}
                                onBlur={() => validateInput('zip', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'zip' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Ταχυδρομικό Κώδικα / Enter Zip Code
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br />

                </Container>

                <br></br>

                <Container>

                    <h4 className='text-decoration-underline'>Number Range</h4> <br></br>

                    <Row>
                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>

                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number range start*</th>
                                <th>Number range end*</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    {/* Start Range */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`}
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                const isValid = /^\d+$/.test(value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`startNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^\d+$/.test(row.sNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the start number in a range
                                            </div>
                                        )}
                                        {validationStates[`startNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    {/* End Number */}
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`}
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                const isValid = /^\d+$/.test(value); // Exactly 11 digits
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`endNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^\d+$/.test(row.eNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Enter the end number in a range
                                            </div>
                                        )}
                                        {validationStates[`endNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>
                    <button onClick={addRow_range}>Add Row</button>

                    <br></br><br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('provider')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Επωνυμία Παρόχου Δέκτη / Recipient Provider Name*</label> <br />
                            <input
                                onChange={(e) => setProvider(e.target.value)}
                                type="text"
                                id="provider"
                                placeholder=""
                                className={`inputbox ${validationStates.provider === false ? 'error' : ''}`}
                                onBlur={() => validateInput('provider', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'provider' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Επωνυμία Παρόχου Δέκτη / Enter Recipient Provider Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('signature')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>ΥΠΟΓΡΑΦΗ ΠΕΛΑΤΗ ή ΝΟΜΙΜΟΥ ΕΚΠΡΟΣΩΠΟΥ / SIGNATURE*</label> <br />
                            <input
                                onChange={(e) => setSignature(e.target.value)}
                                type="text"
                                id="signature"
                                placeholder=""
                                className={`inputbox ${validationStates.signature === false ? 'error' : ''}`}
                                onBlur={() => validateInput('signature', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'signature' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Υπογραφή Πελάτη ή Νόμιμου Εκπροσώπου / Enter Signature
                                </div>
                            )}
                        </Col>


                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('companyStamp')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>ΣΦΡΑΓΙΔΑ ΕΤΑΙΡΙΑΣ  /  COMPANY STAMP*</label> <br />
                            <input
                                onChange={(e) => setCompanyStamp(e.target.value)}
                                type="text"
                                id="companyStamp"
                                placeholder=""
                                className={`inputbox ${validationStates.companyStamp === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyStamp', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'companyStamp' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Σφραγίδα Εταιρίας / Enter Company Stamp
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('place')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Τόπος / Place*</label> <br />
                            <input
                                onChange={(e) => setPlace(e.target.value)}
                                type="text"
                                id="place"
                                placeholder=""
                                className={`inputbox ${validationStates.place === false ? 'error' : ''}`}
                                onBlur={() => validateInput('place', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'place' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Τόπο / Enter Place
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('date')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Ημερομηνία / Date*</label> <br />
                            <input
                                type="date"
                                id="date"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                min={new Date().toISOString().slice(0, 16)} // Disable past dates
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                            />
                            {hoveredField === 'date' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Ημερομηνία / Enter Date
                                </div>
                            )}
                        </Col>

                    </Row>


                </Container>

                <br></br><br></br>

                <Container>
                    <h2 className='heading'>ΣΤΟΙΧΕΙΑ ΠΕΛΑΤΗ / CUSTOMER DETAILS</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('legalRep')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label style={{ whiteSpace: 'nowrap' }}>
                                Όνοματεπώνυμο Νόμιμου Εκπροσώπου / Legal Representative’s Full Name*
                            </label>
                            <br />
                            <input
                                onChange={(e) => setLegalRep(e.target.value)}
                                type="text"
                                id="legalRep"
                                placeholder=""
                                className={`inputbox ${validationStates.legalRep === false ? 'error' : ''}`}
                                onBlur={() => validateInput('legalRep', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'legalRep' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Όνοματεπώνυμο Νόμιμου Εκπροσώπου / Enter Legal Representative’s Full Name
                                </div>
                            )}
                        </Col>

                    </Row>
                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('signatureCust')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label style={{ whiteSpace: 'nowrap' }}>
                                ΥΠΟΓΡΑΦΗ ΠΕΛΑΤΗ ή ΝΟΜΙΜΟΥ ΕΚΠΡΟΣΩΠΟΥ / SIGNATURE*
                            </label>
                            <br />
                            <input
                                onChange={(e) => setSignatureCust(e.target.value)}
                                type="text"
                                id="signatureCust"
                                placeholder=""
                                className={`inputbox ${validationStates.signatureCust === false ? 'error' : ''}`}
                                onBlur={() => validateInput('signatureCust', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'signatureCust' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Υπογραφή Πελάτη ή Νόμιμου Εκπροσώπου / Enter Signature
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('companyStampCust')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>ΣΦΡΑΓΙΔΑ ΕΤΑΙΡΙΑΣ / COMPANY STAMP*</label> <br />
                            <input
                                onChange={(e) => setCompanyStampCust(e.target.value)}
                                type="text"
                                id="companyStampCust"
                                placeholder=""
                                className={`inputbox ${validationStates.companyStampCust === false ? 'error' : ''}`}
                                onBlur={() => validateInput('companyStampCust', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'companyStampCust' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Σφραγίδα Εταιρίας / Enter Company Stamp
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('placeCust')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Τόπος / Place*</label> <br />
                            <input
                                onChange={(e) => setPlaceCust(e.target.value)}
                                type="text"
                                id="placeCust"
                                placeholder=""
                                className={`inputbox ${validationStates.placeCust === false ? 'error' : ''}`}
                                onBlur={() => validateInput('placeCust', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'placeCust' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Τόπο / Enter Place
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('dateCust')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Ημερομηνία / Date*</label> <br />
                            <input
                                type="date"
                                id="dateCust"
                                value={dateCust}
                                onChange={(e) => setDateCust(e.target.value)}
                                min={new Date().toISOString().slice(0, 16)} // Disable past dates
                                className={`inputbox ${validationStates.dateCust === false ? 'error' : ''}`}
                                onBlur={() => validateInput('dateCust', /^.*$/)}
                            />
                            {hoveredField === 'dateCust' && (
                                <div className="hover-description">
                                    Πληκτρολογήστε Ημερομηνία / Enter Date
                                </div>
                            )}
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Greece;